"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var companyappApi = _interopRequireWildcard(require("@/api/companyappApi.js"));
var _utils = require("@/utils");
var _auditMediaUpload = _interopRequireDefault(require("./auditMediaUpload.vue"));
var _auditDetail = _interopRequireDefault(require("./auditDetail.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t12 in e) "default" !== _t12 && {}.hasOwnProperty.call(e, _t12) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t12)) && (i.get || i.set) ? o(f, _t12, i) : f[_t12] = e[_t12]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var UPLOAD_STATUS = {
  CREATED: {
    label: '已创建',
    type: ''
  },
  WAITING_RUNNER: {
    label: '等待Runner',
    type: 'warning'
  },
  CLONING: {
    label: '拉取代码中',
    type: 'warning'
  },
  CHECKING: {
    label: '校验中',
    type: 'warning'
  },
  WAITING_BUILD: {
    label: '等待编译',
    type: 'warning'
  },
  BUILDING: {
    label: '编译中',
    type: 'warning'
  },
  UPLOADING: {
    label: '上传中',
    type: 'warning'
  },
  SUCCESS: {
    label: '上传成功',
    type: 'success'
  },
  FAILED: {
    label: '上传失败',
    type: 'danger'
  },
  CANCELED: {
    label: '已取消',
    type: 'info'
  }
};
var UPLOAD_CHANNEL = {
  DIRECT: {
    label: '直传',
    tip: '用小程序上传密钥直传，只产生开发版本，体验版需在微信公众平台手动设置'
  },
  TEMPLATE: {
    label: '模板',
    tip: '通过第三方平台模板上传，微信侧会直接生成体验版'
  }
};
var TRIAL_STATUS = {
  NOT_REQUESTED: {
    label: '未申请',
    type: 'info'
  },
  WAITING: {
    label: '等待上传',
    type: 'warning'
  },
  SETTING: {
    label: '切换中',
    type: 'warning'
  },
  ACTIVE: {
    label: '当前体验版',
    type: 'success'
  },
  REPLACED: {
    label: '已被替换',
    type: 'info'
  },
  FAILED: {
    label: '切换失败',
    type: 'danger'
  },
  NOT_SET: {
    label: '未设置',
    type: 'warning'
  },
  MANUAL_REQUIRED: {
    label: '需人工设置',
    type: 'warning'
  }
};
var AUDIT_STATUS = {
  CREATED: {
    label: '已创建',
    type: ''
  },
  WAITING_API: {
    label: '接口待接入',
    type: 'warning'
  },
  SUBMITTING: {
    label: '提交中',
    type: 'warning'
  },
  PENDING: {
    label: '审核中',
    type: 'warning'
  },
  DELAYED: {
    label: '审核延后',
    type: 'warning'
  },
  PASSED: {
    label: '审核通过',
    type: 'success'
  },
  REJECTED: {
    label: '审核驳回',
    type: 'danger'
  },
  WITHDRAWN: {
    label: '已撤回',
    type: 'info'
  },
  FAILED: {
    label: '提交失败',
    type: 'danger'
  }
};
var PUBLISH_STATUS = {
  CREATED: {
    label: '已创建',
    type: ''
  },
  WAITING_API: {
    label: '接口待接入',
    type: 'warning'
  },
  PUBLISHING: {
    label: '发布中',
    type: 'warning'
  },
  RELEASED: {
    label: '已发布',
    type: 'success'
  },
  FAILED: {
    label: '发布失败',
    type: 'danger'
  }
};
var _default = exports.default = {
  name: 'ReleaseManage',
  components: {
    AuditMediaUpload: _auditMediaUpload.default,
    AuditDetail: _auditDetail.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      detailVisible: false,
      activeTab: 'upload',
      companyApp: {},
      prepareInfo: null,
      remoteBranchOptions: [],
      branchLoading: false,
      branchLoadError: '',
      uploadForm: this.getDefaultUploadForm(),
      uploadRules: {
        branchName: [{
          required: true,
          message: '请选择或输入Git分支',
          trigger: 'change'
        }],
        uniAppId: [{
          required: true,
          message: '请输入UniAppID',
          trigger: 'blur'
        }, {
          pattern: /^__UNI__[0-9A-Za-z]+$/,
          message: 'UniAppID格式不正确',
          trigger: 'blur'
        }],
        environmentCode: [{
          required: true,
          message: '请选择接口环境',
          trigger: 'change'
        }],
        customDomain: [{
          required: true,
          message: '请输入自定义HTTPS域名',
          trigger: 'blur'
        }],
        versionNo: [{
          required: true,
          message: '请输入版本号',
          trigger: 'blur'
        }],
        versionDesc: [{
          required: true,
          message: '请输入版本描述',
          trigger: 'blur'
        }],
        robotNo: [{
          required: true,
          message: '请输入CI机器人编号',
          trigger: 'change'
        }]
      },
      createLoading: false,
      wechatSyncLoading: false,
      actionId: null,
      versionLoading: false,
      versionList: [],
      versionTotal: 0,
      versionPage: {
        page: 1,
        limit: 10
      },
      prodLoading: false,
      prodVersionList: [],
      prodTotal: 0,
      prodPage: {
        page: 1,
        limit: 10
      },
      auditLoading: false,
      auditList: [],
      auditTotal: 0,
      auditPage: {
        page: 1,
        limit: 10
      },
      auditDialogVisible: false,
      auditPrepareLoading: false,
      auditSubmitLoading: false,
      auditVersion: null,
      auditSourceRecord: null,
      auditPrepare: null,
      auditForm: this.getDefaultAuditForm(),
      auditFormSeq: 0,
      auditMediaBusy: {},
      passedLoading: false,
      passedAuditList: [],
      publishLoading: false,
      publishList: [],
      publishTotal: 0,
      publishPage: {
        page: 1,
        limit: 10
      },
      versionDetail: null,
      qrcodeVisible: false,
      qrcodeLoading: false,
      qrcodeVersion: null,
      qrcodePath: '',
      qrcodeUrl: '',
      qrcodeError: '',
      qrcodeRequestSeq: 0
    };
  },
  computed: {
    branchOptions: function branchOptions() {
      var defaultBranch = this.prepareInfo && this.prepareInfo.defaultBranch;
      var branches = defaultBranch ? [defaultBranch].concat(_toConsumableArray(this.remoteBranchOptions)) : _toConsumableArray(this.remoteBranchOptions);
      return _toConsumableArray(new Set(branches.filter(Boolean)));
    },
    environmentOptions: function environmentOptions() {
      return this.prepareInfo && this.prepareInfo.environmentOptions || [];
    },
    targetDomainPreview: function targetDomainPreview() {
      var _this = this;
      var item = this.environmentOptions.find(function (env) {
        return env.code === _this.uploadForm.environmentCode;
      });
      return item && item.domain || '';
    },
    wechatApiReadyTip: function wechatApiReadyTip() {
      var tip = '当前小程序未完成微信第三方平台授权或缺少代码权限，体验版同步和微信接口调用会失败，请先到“小程序授权”完成授权。';
      var extra = this.prepareInfo && this.prepareInfo.onlineVersionTip || '';
      return extra ? "".concat(tip, "\uFF08").concat(extra, "\uFF09") : tip;
    },
    auditPageOptions: function auditPageOptions() {
      return this.auditPrepare && this.auditPrepare.pageList || [];
    },
    auditCategoryOptions: function auditCategoryOptions() {
      return this.auditPrepare && this.auditPrepare.categoryList || [];
    },
    auditMediaUploading: function auditMediaUploading() {
      return Object.values(this.auditMediaBusy).some(Boolean);
    },
    auditSourceTip: function auditSourceTip() {
      if (!this.auditSourceRecord) return '';
      var reason = this.auditSourceRecord.rejectReason || this.auditSourceRecord.errorMessage || '';
      var text = String(reason).replace(/<br\s*\/?\s*>/gi, '\n').replace(/<[^>]+>/g, '');
      var reminder = '请先解决驳回或失败原因，再确认提审。历史图片和录屏仅回显素材ID，可能已经过期，建议删除后重新上传。';
      return text ? "".concat(text, "\n").concat(reminder) : reminder;
    }
  },
  methods: {
    getDefaultUploadForm: function getDefaultUploadForm() {
      return {
        companyAppId: null,
        branchName: '',
        uniAppId: '',
        environmentCode: 'VIR',
        customDomain: '',
        versionNo: '',
        versionDesc: '',
        robotNo: 3,
        trialRequested: true
      };
    },
    open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.companyApp = row || {};
              this.dialogVisible = true;
              this.activeTab = 'upload';
              _context.n = 1;
              return this.loadPrepare();
            case 1:
              _context.n = 2;
              return Promise.all([this.loadBranchOptions(), this.loadVersionList()]);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function open(_x) {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    loadPrepare: function () {
      var _loadPrepare = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _ref,
          _ref$preserveBranchNa,
          preserveBranchName,
          selectedBranchName,
          selectedUniAppId,
          data,
          _args2 = arguments,
          _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _ref = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref$preserveBranchNa = _ref.preserveBranchName, preserveBranchName = _ref$preserveBranchNa === void 0 ? false : _ref$preserveBranchNa;
              if (this.companyApp.id) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              selectedBranchName = preserveBranchName ? this.uploadForm.branchName : '';
              selectedUniAppId = preserveBranchName ? this.uploadForm.uniAppId : '';
              _context2.p = 2;
              _context2.n = 3;
              return companyappApi.getMiniProgramPrepareApi(this.companyApp.id);
            case 3:
              data = _context2.v;
              this.prepareInfo = data;
              this.uploadForm = _objectSpread(_objectSpread({}, this.getDefaultUploadForm()), {}, {
                companyAppId: data.companyAppId,
                branchName: selectedBranchName || data.defaultBranch || '',
                uniAppId: selectedUniAppId || data.defaultUniAppId || '',
                versionNo: data.suggestedVersion || '',
                robotNo: this.getRobotNoByEnvironment('VIR')
              });
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              this.$message.error(_t || '获取版本管理配置失败');
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4]]);
      }));
      function loadPrepare() {
        return _loadPrepare.apply(this, arguments);
      }
      return loadPrepare;
    }(),
    loadBranchOptions: function () {
      var _loadBranchOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var data, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.branchLoading = true;
              this.branchLoadError = '';
              _context3.p = 1;
              _context3.n = 2;
              return companyappApi.getBatchListApi();
            case 2:
              data = _context3.v;
              this.remoteBranchOptions = Array.isArray(data) ? _toConsumableArray(new Set(data.map(function (item) {
                return String(item).trim();
              }).filter(Boolean))).sort() : [];
              if (!this.uploadForm.branchName && this.remoteBranchOptions.length) {
                this.uploadForm.branchName = this.remoteBranchOptions[0];
              }
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              this.remoteBranchOptions = [];
              this.branchLoadError = typeof _t2 === 'string' ? _t2 : '远程分支获取失败';
            case 4:
              _context3.p = 4;
              this.branchLoading = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function loadBranchOptions() {
        return _loadBranchOptions.apply(this, arguments);
      }
      return loadBranchOptions;
    }(),
    createAndSubmitUpload: function createAndSubmitUpload() {
      var _this2 = this;
      if (this.uploadForm.environmentCode === 'CUSTOM' && !this.uploadForm.customDomain) {
        this.$message.warning('请输入自定义HTTPS域名');
        return;
      }
      if (this.uploadForm.trialRequested && !(this.prepareInfo && this.prepareInfo.wechatApiReady)) {
        this.$message.warning('当前小程序尚未完成微信第三方平台授权或缺少代码权限，无法自动更新体验版');
        return;
      }
      this.$refs.uploadForm.validate(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(valid) {
          var version, _t3;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.p = _context4.n) {
              case 0:
                if (valid) {
                  _context4.n = 1;
                  break;
                }
                return _context4.a(2);
              case 1:
                _this2.createLoading = true;
                _context4.p = 2;
                _context4.n = 3;
                return companyappApi.createMiniProgramVersionApi(_this2.uploadForm);
              case 3:
                version = _context4.v;
                _context4.n = 4;
                return companyappApi.submitMiniProgramUploadApi(version.id);
              case 4:
                _this2.$message.success('上传任务已创建并提交');
                _context4.n = 5;
                return _this2.loadVersionList();
              case 5:
                _context4.n = 6;
                return _this2.loadPrepare({
                  preserveBranchName: true
                });
              case 6:
                _context4.n = 8;
                break;
              case 7:
                _context4.p = 7;
                _t3 = _context4.v;
              case 8:
                _context4.p = 8;
                _this2.createLoading = false;
                return _context4.f(8);
              case 9:
                return _context4.a(2);
            }
          }, _callee4, null, [[2, 7, 8, 9]]);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    getRobotNoByEnvironment: function getRobotNoByEnvironment(code) {
      var currentRobotNo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
      var fixedRobotNos = {
        PROD: 1,
        PRE: 2,
        VIR: 3,
        LOCALTEST: 4
      };
      if (fixedRobotNos[code]) return fixedRobotNos[code];
      return currentRobotNo >= 5 && currentRobotNo <= 30 ? currentRobotNo : 5;
    },
    handleUploadEnvironmentChange: function handleUploadEnvironmentChange(code) {
      this.uploadForm.robotNo = this.getRobotNoByEnvironment(code, this.uploadForm.robotNo);
    },
    resetUploadForm: function resetUploadForm() {
      var _this3 = this;
      var data = this.prepareInfo || {};
      this.uploadForm = _objectSpread(_objectSpread({}, this.getDefaultUploadForm()), {}, {
        companyAppId: data.companyAppId || null,
        branchName: data.defaultBranch || this.remoteBranchOptions[0] || '',
        uniAppId: data.defaultUniAppId || '',
        versionNo: data.suggestedVersion || '',
        robotNo: this.getRobotNoByEnvironment('VIR')
      });
      this.$nextTick(function () {
        return _this3.$refs.uploadForm && _this3.$refs.uploadForm.clearValidate();
      });
    },
    handleTabClick: function () {
      var _handleTabClick = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(tab) {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return this.loadTabData(tab.name);
            case 1:
              _context5.p = 1;
              this.layoutAuditTables();
              return _context5.f(1);
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this, [[0,, 1, 2]]);
      }));
      function handleTabClick(_x3) {
        return _handleTabClick.apply(this, arguments);
      }
      return handleTabClick;
    }(),
    layoutAuditTables: function layoutAuditTables() {
      var _this4 = this;
      // 隐藏的 Tab 首次显示后重新计算，避免操作按钮所在行高度沿用隐藏状态。
      this.$nextTick(function () {
        ['prodVersionTable', 'auditRecordTable'].forEach(function (name) {
          var table = _this4.$refs[name];
          if (table) table.doLayout();
        });
      });
    },
    loadTabData: function loadTabData(name) {
      if (name === 'upload') return this.loadVersionList();
      if (name === 'audit') return Promise.all([this.loadProdVersions(), this.loadAuditList()]);
      if (name === 'publish') return Promise.all([this.loadPassedAudits(), this.loadPublishList()]);
      return Promise.resolve();
    },
    loadVersionList: function () {
      var _loadVersionList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              if (this.companyApp.id) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              this.versionLoading = true;
              _context6.p = 2;
              _context6.n = 3;
              return companyappApi.getMiniProgramVersionListApi(_objectSpread({
                companyAppId: this.companyApp.id
              }, this.versionPage));
            case 3:
              data = _context6.v;
              this.versionList = data.list || [];
              this.versionTotal = data.total || 0;
            case 4:
              _context6.p = 4;
              this.versionLoading = false;
              return _context6.f(4);
            case 5:
              return _context6.a(2);
          }
        }, _callee6, this, [[2,, 4, 5]]);
      }));
      function loadVersionList() {
        return _loadVersionList.apply(this, arguments);
      }
      return loadVersionList;
    }(),
    loadProdVersions: function () {
      var _loadProdVersions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var data;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              if (this.companyApp.id) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              this.prodLoading = true;
              _context7.p = 2;
              _context7.n = 3;
              return companyappApi.getMiniProgramVersionListApi(_objectSpread({
                companyAppId: this.companyApp.id,
                environmentCode: 'PROD'
              }, this.prodPage));
            case 3:
              data = _context7.v;
              this.prodVersionList = data.list || [];
              this.prodTotal = data.total || 0;
            case 4:
              _context7.p = 4;
              this.prodLoading = false;
              return _context7.f(4);
            case 5:
              return _context7.a(2);
          }
        }, _callee7, this, [[2,, 4, 5]]);
      }));
      function loadProdVersions() {
        return _loadProdVersions.apply(this, arguments);
      }
      return loadProdVersions;
    }(),
    loadAuditList: function () {
      var _loadAuditList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var data;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              if (this.companyApp.id) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              this.auditLoading = true;
              _context8.p = 2;
              _context8.n = 3;
              return companyappApi.getMiniProgramAuditListApi(_objectSpread({
                companyAppId: this.companyApp.id
              }, this.auditPage));
            case 3:
              data = _context8.v;
              this.auditList = data.list || [];
              this.auditTotal = data.total || 0;
            case 4:
              _context8.p = 4;
              this.auditLoading = false;
              return _context8.f(4);
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this, [[2,, 4, 5]]);
      }));
      function loadAuditList() {
        return _loadAuditList.apply(this, arguments);
      }
      return loadAuditList;
    }(),
    loadPassedAudits: function () {
      var _loadPassedAudits = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var data;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              if (this.companyApp.id) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              this.passedLoading = true;
              _context9.p = 2;
              _context9.n = 3;
              return companyappApi.getMiniProgramAuditListApi({
                companyAppId: this.companyApp.id,
                status: 'PASSED',
                page: 1,
                limit: 100
              });
            case 3:
              data = _context9.v;
              this.passedAuditList = data.list || [];
            case 4:
              _context9.p = 4;
              this.passedLoading = false;
              return _context9.f(4);
            case 5:
              return _context9.a(2);
          }
        }, _callee9, this, [[2,, 4, 5]]);
      }));
      function loadPassedAudits() {
        return _loadPassedAudits.apply(this, arguments);
      }
      return loadPassedAudits;
    }(),
    loadPublishList: function () {
      var _loadPublishList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var data;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              if (this.companyApp.id) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              this.publishLoading = true;
              _context0.p = 2;
              _context0.n = 3;
              return companyappApi.getMiniProgramPublishListApi(_objectSpread({
                companyAppId: this.companyApp.id
              }, this.publishPage));
            case 3:
              data = _context0.v;
              this.publishList = data.list || [];
              this.publishTotal = data.total || 0;
            case 4:
              _context0.p = 4;
              this.publishLoading = false;
              return _context0.f(4);
            case 5:
              return _context0.a(2);
          }
        }, _callee0, this, [[2,, 4, 5]]);
      }));
      function loadPublishList() {
        return _loadPublishList.apply(this, arguments);
      }
      return loadPublishList;
    }(),
    submitUpload: function () {
      var _submitUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(row) {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              this.actionId = row.id;
              _context1.p = 1;
              _context1.n = 2;
              return companyappApi.submitMiniProgramUploadApi(row.id);
            case 2:
              this.$message.success('上传任务已重新提交');
              _context1.n = 3;
              return this.loadVersionList();
            case 3:
              _context1.p = 3;
              this.actionId = null;
              return _context1.f(3);
            case 4:
              return _context1.a(2);
          }
        }, _callee1, this, [[1,, 3, 4]]);
      }));
      function submitUpload(_x4) {
        return _submitUpload.apply(this, arguments);
      }
      return submitUpload;
    }(),
    cancelUploadTask: function cancelUploadTask(row) {
      var _this5 = this;
      this.$confirm("\u786E\u5B9A\u4E2D\u6B62\u7248\u672C ".concat(row.versionNo, " \u7684\u4E0A\u4F20\u4EFB\u52A1\uFF1F"), '中止上传', {
        type: 'warning',
        confirmButtonText: '确认中止'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              _this5.actionId = row.id;
              _context10.p = 1;
              _context10.n = 2;
              return companyappApi.cancelMiniProgramUploadApi(row.id);
            case 2:
              _this5.$message.success('已发出中止指令');
              _context10.n = 3;
              return _this5.loadVersionList();
            case 3:
              if (!(_this5.versionDetail && _this5.versionDetail.id === row.id)) {
                _context10.n = 5;
                break;
              }
              _context10.n = 4;
              return companyappApi.getMiniProgramVersionDetailApi(row.id);
            case 4:
              _this5.versionDetail = _context10.v;
            case 5:
              _context10.p = 5;
              _this5.actionId = null;
              return _context10.f(5);
            case 6:
              return _context10.a(2);
          }
        }, _callee10, null, [[1,, 5, 6]]);
      }))).catch(function () {});
    },
    requestTrial: function () {
      var _requestTrial = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(row) {
        var data;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              this.actionId = row.id;
              _context11.p = 1;
              _context11.n = 2;
              return companyappApi.requestMiniProgramTrialApi(row.id);
            case 2:
              data = _context11.v;
              if (data.trialStatus === 'ACTIVE') {
                this.$message.success('已设为当前体验版');
              } else if (['WAITING', 'SETTING'].includes(data.trialStatus)) {
                this.$message.success('原草稿已失效，正在按原Git提交重新构建，完成后将自动设为体验版');
              } else {
                this.$message.info('设置体验版请求已提交');
              }
              _context11.n = 3;
              return this.loadVersionList();
            case 3:
              _context11.p = 3;
              this.actionId = null;
              return _context11.f(3);
            case 4:
              return _context11.a(2);
          }
        }, _callee11, this, [[1,, 3, 4]]);
      }));
      function requestTrial(_x5) {
        return _requestTrial.apply(this, arguments);
      }
      return requestTrial;
    }(),
    getDefaultAuditItem: function getDefaultAuditItem() {
      return {
        address: '',
        categoryIndex: null,
        title: '',
        tag: ''
      };
    },
    getDefaultAuditForm: function getDefaultAuditForm() {
      return {
        versionDesc: '',
        itemList: [],
        previewImageIds: [],
        previewVideoIds: [],
        orderPath: '',
        privacyApiNotUse: '',
        feedbackInfo: '',
        feedbackImageIds: [],
        speedupRequested: false
      };
    },
    handleAuditItemPageChange: function handleAuditItemPageChange(item) {
      var title = item.address === 'pages/index/index' ? '首页' : '';
      // 仅替换默认值，保留配置人员手动填写的标题。
      if (!item.title || item.title === '首页') item.title = title;
    },
    closeAuditDialog: function closeAuditDialog(done) {
      if (this.auditSubmitLoading || this.auditMediaUploading) {
        this.$message.warning('请等待提审或素材上传完成后再关闭');
        return;
      }
      this.auditDialogVisible = false;
      if (typeof done === 'function') done();
    },
    getAuditRecordPayload: function getAuditRecordPayload(record) {
      if (!record) return {};
      try {
        var payload = typeof record.submitPayload === 'string' ? JSON.parse(record.submitPayload) : record.submitPayload;
        if (payload && _typeof(payload) === 'object' && !Array.isArray(payload)) return payload;
      } catch (_unused2) {
        // 历史参数异常时仍允许人工填写，不能改用上传描述冒充提审描述。
      }
      this.$message.warning('未能读取该记录的历史提审参数，请重新填写后提交');
      return {};
    },
    normalizeAuditMediaIds: function normalizeAuditMediaIds(ids) {
      return Array.isArray(ids) ? _toConsumableArray(new Set(ids.filter(function (value) {
        return typeof value === 'string';
      }).map(function (value) {
        return value.trim();
      }).filter(Boolean))) : [];
    },
    restoreAuditItem: function restoreAuditItem(source) {
      var item = this.getDefaultAuditItem();
      item.address = this.auditPageOptions.includes(source.address) ? source.address : '';
      item.title = source.title || '';
      item.tag = source.tag || '';
      var index = this.auditCategoryOptions.findIndex(function (category) {
        return String(category.firstId) === String(source.firstId) && String(category.secondId) === String(source.secondId) && String(category.thirdId || '') === String(source.thirdId || '');
      });
      item.categoryIndex = index < 0 ? null : index;
      this.handleAuditItemPageChange(item);
      return item;
    },
    resubmitAudit: function () {
      var _resubmitAudit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(record) {
        var version, _t4;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              if (!(!this.canResubmitAudit(record) || this.actionId !== null)) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2);
            case 1:
              this.actionId = record.id;
              _context12.p = 2;
              _context12.n = 3;
              return companyappApi.getMiniProgramVersionDetailApi(record.versionId);
            case 3:
              version = _context12.v;
              if (version.auditEligible) {
                _context12.n = 4;
                break;
              }
              this.$message.warning(version.auditDisabledReason || '原上传版本目前不满足提审条件，请先检查当前体验版及审核状态');
              return _context12.a(2);
            case 4:
              _context12.n = 5;
              return this.openAuditDialog(version, record);
            case 5:
              _context12.n = 7;
              break;
            case 6:
              _context12.p = 6;
              _t4 = _context12.v;
            case 7:
              _context12.p = 7;
              this.actionId = null;
              return _context12.f(7);
            case 8:
              return _context12.a(2);
          }
        }, _callee12, this, [[2, 6, 7, 8]]);
      }));
      function resubmitAudit(_x6) {
        return _resubmitAudit.apply(this, arguments);
      }
      return resubmitAudit;
    }(),
    openAuditDialog: function () {
      var _openAuditDialog = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(row) {
        var _this6 = this;
        var sourceRecord,
          payload,
          formSeq,
          preparation,
          previousItems,
          firstItem,
          _args13 = arguments,
          _t5;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              sourceRecord = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : null;
              payload = this.getAuditRecordPayload(sourceRecord);
              this.auditVersion = row;
              this.auditSourceRecord = sourceRecord;
              this.auditPrepare = null;
              this.auditForm = _objectSpread(_objectSpread({}, this.getDefaultAuditForm()), {}, {
                versionDesc: sourceRecord ? payload.versionDesc || '' : row.versionDesc || '',
                orderPath: payload.orderPath || '',
                privacyApiNotUse: typeof payload.privacyApiNotUse === 'boolean' ? payload.privacyApiNotUse : '',
                feedbackInfo: payload.feedbackInfo || '',
                previewImageIds: this.normalizeAuditMediaIds(payload.previewInfo && payload.previewInfo.picIdList),
                previewVideoIds: this.normalizeAuditMediaIds(payload.previewInfo && payload.previewInfo.videoIdList),
                feedbackImageIds: this.normalizeAuditMediaIds(typeof payload.feedbackStuff === 'string' ? payload.feedbackStuff.split(/[丨|]/) : []),
                itemList: [this.getDefaultAuditItem()]
              });
              this.auditFormSeq += 1;
              formSeq = this.auditFormSeq;
              this.auditMediaBusy = {};
              this.auditDialogVisible = true;
              this.auditPrepareLoading = true;
              _context13.p = 1;
              _context13.n = 2;
              return companyappApi.getMiniProgramAuditPrepareApi(this.companyApp.id);
            case 2:
              preparation = _context13.v;
              if (!(!this.auditDialogVisible || formSeq !== this.auditFormSeq)) {
                _context13.n = 3;
                break;
              }
              return _context13.a(2);
            case 3:
              this.auditPrepare = preparation;
              previousItems = Array.isArray(payload.itemList) ? payload.itemList : [];
              if (sourceRecord && previousItems.length) {
                this.auditForm.itemList = previousItems.map(function (item) {
                  return _this6.restoreAuditItem(item);
                });
                if (this.auditForm.itemList.some(function (item) {
                  return !item.address || item.categoryIndex === null;
                })) {
                  this.$message.warning('历史审核页面或类目已发生变化，请重新选择缺失的页面或类目');
                }
              } else {
                firstItem = this.auditForm.itemList[0];
                if (this.auditPageOptions.length) firstItem.address = this.auditPageOptions[0];
                this.handleAuditItemPageChange(firstItem);
                if (this.auditCategoryOptions.length) firstItem.categoryIndex = 0;
              }
              _context13.n = 5;
              break;
            case 4:
              _context13.p = 4;
              _t5 = _context13.v;
              if (formSeq === this.auditFormSeq) this.auditDialogVisible = false;
            case 5:
              _context13.p = 5;
              if (formSeq === this.auditFormSeq) this.auditPrepareLoading = false;
              return _context13.f(5);
            case 6:
              return _context13.a(2);
          }
        }, _callee13, this, [[1, 4, 5, 6]]);
      }));
      function openAuditDialog(_x7) {
        return _openAuditDialog.apply(this, arguments);
      }
      return openAuditDialog;
    }(),
    addAuditItem: function addAuditItem() {
      if (this.auditForm.itemList.length >= 5) return;
      var item = this.getDefaultAuditItem();
      if (this.auditPageOptions.length) item.address = this.auditPageOptions[0];
      this.handleAuditItemPageChange(item);
      if (this.auditCategoryOptions.length) item.categoryIndex = 0;
      this.auditForm.itemList.push(item);
    },
    removeAuditItem: function removeAuditItem(index) {
      this.auditForm.itemList.splice(index, 1);
    },
    categoryLabel: function categoryLabel(category) {
      return [category.firstClass, category.secondClass, category.thirdClass].filter(Boolean).join(' / ');
    },
    categoryKey: function categoryKey(category, index) {
      return [category.firstId, category.secondId, category.thirdId, index].filter(function (value) {
        return value !== null && value !== undefined;
      }).join('_');
    },
    validateAuditForm: function validateAuditForm() {
      if (!this.auditForm.itemList.length) return '至少添加一个审核页面';
      if (this.auditForm.itemList.length > 5) return '审核页面不能超过5个';
      if (this.auditMediaUploading) return '请等待提审素材上传完成';
      var orderPath = this.auditForm.orderPath;
      if (orderPath && (/^\//.test(orderPath) || /[\s:?#]/.test(orderPath))) {
        return '订单中心Path不能以/开头，且不能包含域名或参数';
      }
      for (var index = 0; index < this.auditForm.itemList.length; index += 1) {
        var item = this.auditForm.itemList[index];
        if (!item.address) return "\u8BF7\u9009\u62E9\u9875\u9762 ".concat(index + 1, " \u7684\u8DEF\u5F84");
        if (item.categoryIndex === null || item.categoryIndex === undefined) return "\u8BF7\u9009\u62E9\u9875\u9762 ".concat(index + 1, " \u7684\u7C7B\u76EE");
        if (!item.title) return "\u8BF7\u586B\u5199\u9875\u9762 ".concat(index + 1, " \u7684\u6807\u9898");
      }
      return '';
    },
    confirmSubmitAudit: function () {
      var _confirmSubmitAudit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var _this7 = this;
        var message, itemList, audit, reason, _t6, _t7;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              if (!(this.auditSubmitLoading || this.auditPrepareLoading)) {
                _context14.n = 1;
                break;
              }
              return _context14.a(2);
            case 1:
              message = this.validateAuditForm();
              if (!message) {
                _context14.n = 2;
                break;
              }
              this.$message.warning(message);
              return _context14.a(2);
            case 2:
              itemList = this.auditForm.itemList.map(function (item) {
                var category = _this7.auditCategoryOptions[item.categoryIndex];
                return {
                  address: item.address,
                  tag: item.tag,
                  title: item.title,
                  firstClass: category.firstClass,
                  secondClass: category.secondClass,
                  thirdClass: category.thirdClass,
                  firstId: category.firstId,
                  secondId: category.secondId,
                  thirdId: category.thirdId
                };
              });
              this.auditSubmitLoading = true;
              _context14.p = 3;
              _context14.n = 4;
              return companyappApi.submitMiniProgramAuditV2Api({
                versionId: this.auditVersion.id,
                versionDesc: this.auditForm.versionDesc,
                itemList: itemList,
                previewInfo: this.auditForm.previewImageIds.length || this.auditForm.previewVideoIds.length ? {
                  picIdList: this.auditForm.previewImageIds,
                  videoIdList: this.auditForm.previewVideoIds
                } : null,
                orderPath: this.auditForm.orderPath || null,
                privacyApiNotUse: this.auditForm.privacyApiNotUse === '' ? null : this.auditForm.privacyApiNotUse,
                feedbackInfo: this.auditForm.feedbackInfo || null,
                feedbackStuff: this.auditForm.feedbackImageIds.join('丨') || null
              });
            case 4:
              audit = _context14.v;
              if (!this.auditForm.speedupRequested) {
                _context14.n = 9;
                break;
              }
              _context14.p = 5;
              _context14.n = 6;
              return companyappApi.speedupMiniProgramAuditApi(audit.id, {
                skipGlobalErrorMessage: true
              });
            case 6:
              this.$message.success('已提交微信审核，并已申请加急');
              _context14.n = 8;
              break;
            case 7:
              _context14.p = 7;
              _t6 = _context14.v;
              // 自动加急单独提示，避免重复报错，且明确审核单已经提交成功。
              reason = typeof _t6 === 'string' ? _t6 : _t6 && _t6.message;
              this.$message.warning("\u5FAE\u4FE1\u5BA1\u6838\u5DF2\u63D0\u4EA4\u6210\u529F\uFF0C\u4F46\u52A0\u6025\u7533\u8BF7\u5931\u8D25".concat(reason ? "\uFF1A".concat(reason) : '', "\uFF0C\u53EF\u5728\u5BA1\u6838\u8BB0\u5F55\u4E2D\u91CD\u8BD5\u52A0\u6025"));
            case 8:
              _context14.n = 10;
              break;
            case 9:
              this.$message.success('已提交微信审核');
            case 10:
              this.auditDialogVisible = false;
              _context14.n = 11;
              return Promise.all([this.loadProdVersions(), this.loadAuditList()]);
            case 11:
              _context14.n = 13;
              break;
            case 12:
              _context14.p = 12;
              _t7 = _context14.v;
              _context14.n = 13;
              return this.loadAuditList();
            case 13:
              _context14.p = 13;
              this.auditSubmitLoading = false;
              return _context14.f(13);
            case 14:
              return _context14.a(2);
          }
        }, _callee14, this, [[5, 7], [3, 12, 13, 14]]);
      }));
      function confirmSubmitAudit() {
        return _confirmSubmitAudit.apply(this, arguments);
      }
      return confirmSubmitAudit;
    }(),
    viewAuditDetail: function viewAuditDetail(row) {
      this.$refs.auditDetail.open(row);
    },
    speedupAudit: function speedupAudit(row) {
      var _this8 = this;
      this.$confirm("\u786E\u8BA4\u7533\u8BF7\u52A0\u6025\u5BA1\u6838\u7248\u672C ".concat(row.versionNo, "\uFF1F\u5FAE\u4FE1\u4F1A\u6821\u9A8C\u52A0\u6025\u989D\u5EA6\u3002"), '加急审核', {
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.p = _context15.n) {
            case 0:
              _this8.actionId = row.id;
              _context15.p = 1;
              _context15.n = 2;
              return companyappApi.speedupMiniProgramAuditApi(row.id);
            case 2:
              _this8.$message.success('已向微信提交加急审核申请');
            case 3:
              _context15.p = 3;
              _this8.actionId = null;
              return _context15.f(3);
            case 4:
              return _context15.a(2);
          }
        }, _callee15, null, [[1,, 3, 4]]);
      }))).catch(function () {});
    },
    undoAudit: function undoAudit(row) {
      var _this9 = this;
      this.$confirm("\u786E\u8BA4\u64A4\u56DE\u7248\u672C ".concat(row.versionNo, " \u7684\u5FAE\u4FE1\u5BA1\u6838\uFF1F"), '撤回审核', {
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.p = _context16.n) {
            case 0:
              _this9.actionId = row.id;
              _context16.p = 1;
              _context16.n = 2;
              return companyappApi.undoMiniProgramAuditApi(row.id);
            case 2:
              _this9.$message.success('审核已撤回');
              _context16.n = 3;
              return Promise.all([_this9.loadProdVersions(), _this9.loadAuditList()]);
            case 3:
              _context16.p = 3;
              _this9.actionId = null;
              return _context16.f(3);
            case 4:
              return _context16.a(2);
          }
        }, _callee16, null, [[1,, 3, 4]]);
      }))).catch(function () {});
    },
    publishVersion: function publishVersion(row) {
      var _this0 = this;
      this.$confirm("\u7248\u672C ".concat(row.versionNo, " \u5C06\u6B63\u5F0F\u4E0A\u7EBF\uFF0C\u662F\u5426\u7EE7\u7EED\uFF1F"), '正式发布确认', {
        type: 'warning',
        confirmButtonText: '确认发布'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        var _t8;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.p = _context17.n) {
            case 0:
              _this0.actionId = row.id;
              _context17.p = 1;
              _context17.n = 2;
              return companyappApi.publishMiniProgramAuditApi(row.id);
            case 2:
              _this0.$message.success('微信正式发布成功');
              _context17.n = 3;
              return Promise.all([_this0.loadPrepare({
                preserveBranchName: true
              }), _this0.loadPassedAudits(), _this0.loadPublishList()]);
            case 3:
              _context17.n = 5;
              break;
            case 4:
              _context17.p = 4;
              _t8 = _context17.v;
              _context17.n = 5;
              return _this0.loadPublishList();
            case 5:
              _context17.p = 5;
              _this0.actionId = null;
              return _context17.f(5);
            case 6:
              return _context17.a(2);
          }
        }, _callee17, null, [[1, 4, 5, 6]]);
      }))).catch(function () {});
    },
    rollbackRelease: function rollbackRelease() {
      var _this1 = this;
      var onlineVersion = this.prepareInfo && this.prepareInfo.onlineVersion || '当前线上版本';
      this.$confirm("\u786E\u8BA4\u5C06 ".concat(onlineVersion, " \u56DE\u9000\u5230\u5FAE\u4FE1\u5141\u8BB8\u56DE\u9000\u7684\u4E0A\u4E00\u6B63\u5F0F\u7248\u672C\uFF1F"), '回退线上版本', {
        type: 'warning',
        confirmButtonText: '确认回退'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18() {
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              _context18.n = 1;
              return companyappApi.rollbackMiniProgramReleaseApi(_this1.companyApp.id);
            case 1:
              _this1.$message.success('微信线上版本回退成功');
              _context18.n = 2;
              return _this1.loadPrepare({
                preserveBranchName: true
              });
            case 2:
              return _context18.a(2);
          }
        }, _callee18);
      }))).catch(function () {});
    },
    showVersionDetail: function () {
      var _showVersionDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(versionId) {
        var _t9;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.p = _context19.n) {
            case 0:
              _context19.p = 0;
              _context19.n = 1;
              return companyappApi.getMiniProgramVersionDetailApi(versionId);
            case 1:
              this.versionDetail = _context19.v;
              this.detailVisible = true;
              _context19.n = 3;
              break;
            case 2:
              _context19.p = 2;
              _t9 = _context19.v;
              this.$message.error(_t9 || '获取上传版本详情失败');
            case 3:
              return _context19.a(2);
          }
        }, _callee19, this, [[0, 2]]);
      }));
      function showVersionDetail(_x8) {
        return _showVersionDetail.apply(this, arguments);
      }
      return showVersionDetail;
    }(),
    showTrialQrcode: function showTrialQrcode(row) {
      this.qrcodeVersion = row || {};
      this.qrcodePath = '';
      this.qrcodeVisible = true;
      this.loadTrialQrcode();
    },
    loadTrialQrcode: function () {
      var _loadTrialQrcode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20() {
        var versionId, requestId, blob, _t0;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.p = _context20.n) {
            case 0:
              versionId = this.qrcodeVersion && this.qrcodeVersion.id;
              if (versionId) {
                _context20.n = 1;
                break;
              }
              this.qrcodeError = '缺少版本信息，无法获取体验版二维码';
              return _context20.a(2);
            case 1:
              // 每次打开或刷新都丢弃上一张二维码，避免复用旧图。
              this.revokeTrialQrcodeUrl();
              this.qrcodeError = '';
              this.qrcodeLoading = true;
              requestId = ++this.qrcodeRequestSeq;
              _context20.p = 2;
              _context20.n = 3;
              return companyappApi.getMiniProgramTrialQrcodeApi(versionId, this.qrcodePath);
            case 3:
              blob = _context20.v;
              if (!(requestId !== this.qrcodeRequestSeq)) {
                _context20.n = 4;
                break;
              }
              return _context20.a(2);
            case 4:
              _context20.n = 5;
              return this.applyTrialQrcodeBlob(blob, requestId);
            case 5:
              _context20.n = 8;
              break;
            case 6:
              _context20.p = 6;
              _t0 = _context20.v;
              if (!(requestId !== this.qrcodeRequestSeq)) {
                _context20.n = 7;
                break;
              }
              return _context20.a(2);
            case 7:
              _context20.n = 8;
              return this.applyTrialQrcodeError(_t0);
            case 8:
              _context20.p = 8;
              if (requestId === this.qrcodeRequestSeq) {
                this.qrcodeLoading = false;
              }
              return _context20.f(8);
            case 9:
              return _context20.a(2);
          }
        }, _callee20, this, [[2, 6, 8, 9]]);
      }));
      function loadTrialQrcode() {
        return _loadTrialQrcode.apply(this, arguments);
      }
      return loadTrialQrcode;
    }(),
    applyTrialQrcodeBlob: function () {
      var _applyTrialQrcodeBlob = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(blob, requestId) {
        var dataUrl, _t1;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.n) {
            case 0:
              if (!(blob instanceof Blob && blob.type.indexOf('image/') === 0)) {
                _context21.n = 4;
                break;
              }
              if (blob.size) {
                _context21.n = 1;
                break;
              }
              this.qrcodeError = '微信返回的体验版二维码为空';
              return _context21.a(2);
            case 1:
              _context21.n = 2;
              return this.readBlobAsDataUrl(blob);
            case 2:
              dataUrl = _context21.v;
              if (!(requestId !== this.qrcodeRequestSeq || !this.qrcodeVisible)) {
                _context21.n = 3;
                break;
              }
              return _context21.a(2);
            case 3:
              this.qrcodeUrl = dataUrl;
              return _context21.a(2);
            case 4:
              _context21.n = 5;
              return this.readTrialQrcodeError(blob);
            case 5:
              _t1 = _context21.v;
              if (_t1) {
                _context21.n = 6;
                break;
              }
              _t1 = '获取体验版二维码失败';
            case 6:
              this.qrcodeError = _t1;
            case 7:
              return _context21.a(2);
          }
        }, _callee21, this);
      }));
      function applyTrialQrcodeBlob(_x9, _x0) {
        return _applyTrialQrcodeBlob.apply(this, arguments);
      }
      return applyTrialQrcodeBlob;
    }(),
    readBlobAsDataUrl: function readBlobAsDataUrl(blob) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.onerror = function () {
          return reject(reader.error || new Error('读取二维码图片失败'));
        };
        reader.readAsDataURL(blob);
      });
    },
    handleTrialQrcodeImageError: function handleTrialQrcodeImageError() {
      this.qrcodeUrl = '';
      this.qrcodeError = '体验版二维码图片解析失败，请刷新后重试';
    },
    applyTrialQrcodeError: function () {
      var _applyTrialQrcodeError = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(error) {
        var data, message;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              data = error && error.response ? error.response.data : error;
              _context22.n = 1;
              return this.readTrialQrcodeError(data);
            case 1:
              message = _context22.v;
              this.qrcodeError = message || (typeof error === 'string' ? error : '') || '获取体验版二维码失败';
            case 2:
              return _context22.a(2);
          }
        }, _callee22, this);
      }));
      function applyTrialQrcodeError(_x1) {
        return _applyTrialQrcodeError.apply(this, arguments);
      }
      return applyTrialQrcodeError;
    }(),
    readTrialQrcodeError: function () {
      var _readTrialQrcodeError = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(data) {
        var text, result, _t10, _t11;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.p = _context23.n) {
            case 0:
              if (data instanceof Blob) {
                _context23.n = 1;
                break;
              }
              return _context23.a(2, '');
            case 1:
              _context23.p = 1;
              if (!(typeof data.text === 'function')) {
                _context23.n = 3;
                break;
              }
              _context23.n = 2;
              return data.text();
            case 2:
              _t10 = _context23.v;
              _context23.n = 5;
              break;
            case 3:
              _context23.n = 4;
              return new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.onload = function () {
                  return resolve(reader.result);
                };
                reader.onerror = function () {
                  return reject(reader.error);
                };
                reader.readAsText(data);
              });
            case 4:
              _t10 = _context23.v;
            case 5:
              text = _t10;
              result = JSON.parse(text);
              return _context23.a(2, result && result.message || '');
            case 6:
              _context23.p = 6;
              _t11 = _context23.v;
              return _context23.a(2, '');
          }
        }, _callee23, null, [[1, 6]]);
      }));
      function readTrialQrcodeError(_x10) {
        return _readTrialQrcodeError.apply(this, arguments);
      }
      return readTrialQrcodeError;
    }(),
    revokeTrialQrcodeUrl: function revokeTrialQrcodeUrl() {
      if (this.qrcodeUrl) {
        if (this.qrcodeUrl.indexOf('blob:') === 0) {
          URL.revokeObjectURL(this.qrcodeUrl);
        }
        this.qrcodeUrl = '';
      }
    },
    handleTrialQrcodeClose: function handleTrialQrcodeClose() {
      this.qrcodeRequestSeq += 1;
      this.revokeTrialQrcodeUrl();
      this.qrcodeError = '';
      this.qrcodeLoading = false;
      this.qrcodeVersion = null;
    },
    syncWechatVersion: function () {
      var _syncWechatVersion = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24() {
        var data;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.p = _context24.n) {
            case 0:
              if (this.companyApp.id) {
                _context24.n = 1;
                break;
              }
              return _context24.a(2);
            case 1:
              this.wechatSyncLoading = true;
              _context24.p = 2;
              _context24.n = 3;
              return companyappApi.syncMiniProgramWechatVersionApi(this.companyApp.id);
            case 3:
              data = _context24.v;
              this.prepareInfo = _objectSpread(_objectSpread({}, this.prepareInfo), {}, {
                onlineVersion: data.releaseVersion || '',
                onlineVersionTip: data.releaseVersion ? '已从微信开放平台同步' : '微信侧暂无已发布线上版本',
                experienceVersion: data.experienceVersion || '',
                experienceVersionDesc: data.experienceDesc || ''
              });
              this.$message.success('微信状态已同步');
              _context24.n = 4;
              return this.loadVersionList();
            case 4:
              _context24.p = 4;
              this.wechatSyncLoading = false;
              return _context24.f(4);
            case 5:
              return _context24.a(2);
          }
        }, _callee24, this, [[2,, 4, 5]]);
      }));
      function syncWechatVersion() {
        return _syncWechatVersion.apply(this, arguments);
      }
      return syncWechatVersion;
    }(),
    handleVersionPageChange: function handleVersionPageChange(page) {
      this.versionPage.page = page;
      this.loadVersionList();
    },
    handleProdPageChange: function handleProdPageChange(page) {
      this.prodPage.page = page;
      this.loadProdVersions();
    },
    handleAuditPageChange: function handleAuditPageChange(page) {
      this.auditPage.page = page;
      this.loadAuditList();
    },
    handlePublishPageChange: function handlePublishPageChange(page) {
      this.publishPage.page = page;
      this.loadPublishList();
    },
    canSubmitUpload: function canSubmitUpload(status) {
      return status === 'CREATED' || status === 'FAILED';
    },
    canCancelUpload: function canCancelUpload(status) {
      return ['WAITING_RUNNER', 'CLONING', 'CHECKING', 'WAITING_BUILD', 'BUILDING', 'UPLOADING'].includes(status);
    },
    canRequestTrial: function canRequestTrial(row) {
      return row.uploadStatus === 'SUCCESS' && row.uploadChannel === 'TEMPLATE' && ['ACTIVE', 'SETTING'].indexOf(row.trialStatus) === -1;
    },
    canShowTrialQrcode: function canShowTrialQrcode(row) {
      return row.uploadStatus === 'SUCCESS' && Number(row.currentTrial) === 1 && row.trialStatus === 'ACTIVE';
    },
    canPublish: function canPublish(row) {
      return !row.latestPublishStatus || row.latestPublishStatus === 'FAILED';
    },
    canOperateAudit: function canOperateAudit(row) {
      return ['PENDING', 'DELAYED'].includes(row.auditStatus) && !!row.wechatAuditId;
    },
    canResubmitAudit: function canResubmitAudit(row) {
      return ['REJECTED', 'FAILED', 'WITHDRAWN'].includes(row.auditStatus) && !!row.versionId;
    },
    getEnvironmentTagType: function getEnvironmentTagType(code) {
      var types = {
        PROD: 'danger',
        PRE: 'warning',
        VIR: 'success',
        LOCALTEST: 'info',
        CUSTOM: ''
      };
      return types[code] || 'info';
    },
    getUploadStatus: function getUploadStatus(status) {
      return UPLOAD_STATUS[status] || {
        label: status || '-',
        type: 'info'
      };
    },
    getTrialStatus: function getTrialStatus(status) {
      return TRIAL_STATUS[status] || {
        label: status || '-',
        type: 'info'
      };
    },
    getUploadChannelLabel: function getUploadChannelLabel(channel) {
      var item = UPLOAD_CHANNEL[channel];
      return item ? item.label : '-';
    },
    getUploadChannelTip: function getUploadChannelTip(channel) {
      var item = UPLOAD_CHANNEL[channel];
      return item ? item.tip : '';
    },
    getAuditStatus: function getAuditStatus(status) {
      return AUDIT_STATUS[status] || {
        label: status || '未提交',
        type: 'info'
      };
    },
    getPublishStatus: function getPublishStatus(status) {
      return PUBLISH_STATUS[status] || {
        label: status || '未发布',
        type: 'info'
      };
    },
    getCheckStatus: function getCheckStatus(status) {
      var labels = {
        PENDING: '待校验',
        PASSED: '通过',
        FAILED: '失败'
      };
      return labels[status] || status || '-';
    },
    getUploadStep: function getUploadStep(status) {
      var steps = {
        CREATED: 1,
        WAITING_RUNNER: 1,
        CLONING: 2,
        CHECKING: 3,
        WAITING_BUILD: 4,
        BUILDING: 4,
        UPLOADING: 4,
        SUCCESS: 5
      };
      return steps[status] || 1;
    },
    formatDateTime: function formatDateTime(value) {
      return value ? (0, _utils.parseTime)(value, '{y}-{m}-{d} {h}:{i}:{s}') : '-';
    },
    handleClose: function handleClose() {
      if (this.$refs.auditDetail) this.$refs.auditDetail.close();
      this.prepareInfo = null;
      this.remoteBranchOptions = [];
      this.branchLoadError = '';
      this.versionList = [];
      this.prodVersionList = [];
      this.auditList = [];
      this.auditDialogVisible = false;
      this.auditVersion = null;
      this.auditSourceRecord = null;
      this.auditPrepare = null;
      this.auditForm = this.getDefaultAuditForm();
      this.auditFormSeq += 1;
      this.auditMediaBusy = {};
      this.passedAuditList = [];
      this.publishList = [];
      this.versionDetail = null;
      this.detailVisible = false;
      this.qrcodeVisible = false;
      this.qrcodeRequestSeq += 1;
      this.revokeTrialQrcodeUrl();
      this.$emit('closed');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.qrcodeRequestSeq += 1;
    this.revokeTrialQrcodeUrl();
  }
};